import React from 'react';
import { Link } from 'react-router-dom';
import { SUPPORT_LINKS } from '../../config/appConfig';
import { useLanguage } from '../../contexts/LanguageContext';

const Footer = () => {
  const { language, t } = useLanguage();
  const isEn = language === 'en';

  return (
    <footer className="border-t border-white/[0.15] pt-10 pb-[60px] bg-[var(--bg-canvas)]">
      <div className="max-w-[1280px] mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-5">
        <div className="flex flex-col gap-2 max-w-[520px] text-center md:text-left">
          <div className="font-display text-[2rem] tracking-[0.06em] text-white">
            STORMBLACK
          </div>
          <p className="text-[0.88rem] text-white/65 leading-relaxed font-normal">
            {isEn
              ? 'Comprehensive server infrastructure audit and stress-testing system. Perform testing exclusively on resources with confirmed access authorization.'
              : 'Комплексная система аудита стабильности и стресс-тестирования серверной инфраструктуры. Проводите тестирование исключительно на ресурсах с подтвержденным правом доступа.'}
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center md:justify-end gap-2">
          <Link
            to={isEn ? '/en/terms' : '/terms'}
            className="h-9 px-4 rounded-full text-white/80 hover:text-white hover:bg-white/[0.08] font-semibold text-base inline-flex items-center justify-center"
            style={{ transition: 'all 0.22s cubic-bezier(0.16, 1, 0.3, 1)' }}
          >
            {t('termsOfService') || (isEn ? 'Terms of Service' : 'Условия использования')}
          </Link>
          <a
            href={SUPPORT_LINKS.telegram}
            target="_blank"
            rel="noopener noreferrer"
            className="h-9 px-4 rounded-full text-white/80 hover:text-white hover:bg-white/[0.08] font-semibold text-base inline-flex items-center justify-center"
            style={{ transition: 'all 0.22s cubic-bezier(0.16, 1, 0.3, 1)' }}
          >
            Telegram
          </a>
          <a
            href={SUPPORT_LINKS.discord}
            target="_blank"
            rel="noopener noreferrer"
            className="h-9 px-4 rounded-full text-white/80 hover:text-white hover:bg-white/[0.08] font-semibold text-base inline-flex items-center justify-center"
            style={{ transition: 'all 0.22s cubic-bezier(0.16, 1, 0.3, 1)' }}
          >
            Discord
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;